<template>
  <CIcon
    :name="value ? 'cil-check' : 'cil-x'"
    :class="iconClass"
    size="lg"/>
</template>

<script>
export default {
  name: 'PBoolean',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    colorTrue: {
      type: String,
      default: 'success'
    },
    colorFalse: {
      type: String,
      default: 'danger'
    }
  },
  computed: {
    iconClass() {
      return `text-${this.value ? this.colorTrue : this.colorFalse}`
    }
  }
}
</script>

<style scoped>
.text-success {
  color: #2eb85c;
}

.text-danger {
  color: #e55353;
}
</style>
